module["exports"] = [
  "Əhmədov",
  "Ələkbərov",
  "Əliyev",
  "Vəliyev",
  "Soltanov",
  "Quliyev",
  "Məmmədov",
  "Xəlilov",
  "Nəzərov",
  "Rəhimov"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/az/name/male_last_name.js
// module id = 192
// module chunks = 0